import { useOrganizationPermissions } from "src/components/permission/use-organization-permissions";
import { useUser } from "src/contexts/user-context";
import { useMemo } from "react";

export const useHasOrganizationSettings = (): {
  hasAccess: boolean;
  isLoading: boolean;
} => {
  const { user } = useUser();
  const { isOrganizationAdmin, isLoading: isLoadingOrgPermissions } =
    useOrganizationPermissions();

  return useMemo(() => {
    const viaOrgAdmin = isOrganizationAdmin;

    const viaImpersonation = Boolean(user?.is_impersonating);

    return {
      hasAccess: viaOrgAdmin || viaImpersonation,
      isLoading: isLoadingOrgPermissions,
    };
  }, [user?.is_impersonating, isOrganizationAdmin, isLoadingOrgPermissions]);
};
